module.exports = __webpack_public_path__ + "static/img/A6106.4666417d.png";